import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrSelectedPeriod = createSelector(
  [selectQbrState],
  ({ documentSettings }) => documentSettings.selectedPeriod
)
